import RichText from "components/RichText";

type ProductDescriptionProps = {
  description: string;
  descriptionHtml?: string;
};

export default function ProductDescription({
  description,
  descriptionHtml,
}: ProductDescriptionProps) {
  return (
    <RichText
      html={descriptionHtml ?? ""}
      className="mt-4 text-soil"
      fallback={<p className="mt-4 leading-relaxed text-soil">{description}</p>}
    />
  );
}
